import React from "react";
import { Talent } from "@tvg/ts-types/Talent";
import { ButtonVariant } from "@tvg/design-system/web";
import { RaceProgram } from "@tvg/ts-types/Race";
import { WagerTypeCodesEnum } from "@tvg/ts-types/Wager";

export interface BetSlipProps {
  race: RaceProgram;
  races: RaceProgram[];
  selections: string[][];
  onDelete: () => void;
  onPlaceBet?: (totalBetAmount: number) => void;
  onCreatePick?: (totalBetAmount: number, talent: Talent) => void;
  isVisible: boolean;
  isLoading: boolean;
  betType: WagerTypeCodesEnum;
  isBettingDisabled?: boolean;
  isFloating?: boolean;
  isWagerPad?: boolean;
  onClickAlternatesView?: () => void;
  children?: React.ReactNode;
  isTalentPick?: boolean;
}

export interface BetSlipContainerProps {
  isBetSlipExpanded: boolean;
  isError: boolean;
  isExtendedSelections: boolean;
  isFloating?: boolean;
}

export interface AlternateSelectionsMessages {
  infoModal: {
    title: string;
    subtitle: string;
    description: string;
  };
  betslipButton: string;
  alternatesModal: {
    title: string;
    alert: {
      title: string;
      description: string;
    };
    buttons: {
      cancel: string;
      apply: string;
    };
  };
}

export interface BetslipAccountErrorMessages {
  geolocationError: {
    title: string;
    message: string;
    button: string;
  };
  accountComplianceError: {
    title: string;
    message: string;
    button: string;
  };
  termsAndConditionsError: {
    button: string;
  };
}

export interface ButtonDescription {
  text: string;
  variant: ButtonVariant;
  action: string;
}

export interface CustomAmountMessages {
  title: string;
  buttons: ButtonDescription[];
}

export enum SourceKeysEnum {
  FDTV_PICKS = "FDTV Picks",
  TRACKMASTER = "Trackmaster",
  NUMBERFIRE = "numberFire",
  SELECT_ALL_RUNNERS = "Select all modal",
  RACE_CARD = "Race Card",
  REPEAT_BET_RACE_CARD = "repeat_bet_race_card",
  REPEAT_BET_MY_BETS = "repeat_bet_my_bets"
}

export type SourceValue =
  | "fdtv_race_card"
  | "trackmaster_race_card"
  | "numberfire_race_card"
  | "repeat_bet_race_card"
  | "repeat_bet_my_bets"
  | "Race Card";

export type PlaceBetGtm = {
  raceNumber?: string;
  trackName?: string;
  betType?: string;
  betAmount: number;
  selectionSource?: string;
  raceType?: string;
  module?: string;
  specialWagerType?: string;
};

export type RepeatBetEventPayload = {
  betAmount: number;
  betType: string;
  module: string;
  selectionSource: string;
  raceType?: string;
  specialWagerType?: string;
};
